import React, { useState } from 'react';

import styled from 'styled-components';

import { showPeriodNoTime } from '@libs/NwMoment';

import EventTypeTag from '@components/EventDetails/EventTypeTag';
import CustomSelect from '@components/Gui/NwForm/CustomSelect';
import { NwFormItem } from '@components/Gui/NwForm/NwFormWrapper';

// Larghezza minima della tendina: lascia spazio sufficiente affinche
// EventTypeTag, nome evento e periodo restino allineati su un'unica riga.
const DROPDOWN_MIN_WIDTH = 440;

// Wrapper per garantire che le regole sull'opzione raggiungano sia l'item
// selezionato sia le voci del dropdown (la tendina e' renderizzata nel
// parent del trigger tramite getPopupContainer, quindi resta dentro questo
// sottoalbero DOM).
const Wrapper = styled.div`
    .ant-select-selection-item .event-selector-option .name {
        display: block;
    }
    .event-selector-option {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        height: 100%;
        .name {
            margin-left: 10px;
            white-space: nowrap;
        }
        .dates {
            margin-left: auto;
            padding-left: 1rem;
            white-space: nowrap;
            color: rgba(0, 0, 0, 0.45);
            font-size: 0.85em;
        }
    }
`;

const BookingEventSelectorForTransactions = ({ label, eventSelectedUniqID, events, onChange, disabled }) => {
    const [selectedEventUniqID, setSelectedEventUniqID] = useState(eventSelectedUniqID);

    const filteredEvents = events.filter((event) => event.elType === 'Event');

    const eventOptions = filteredEvents.map((event) => ({
        value: event.uniqID,
        label: (
            <div className="event-selector-option">
                <EventTypeTag event={event} />
                <div className="name">{event.Name || event.Title}</div>
                <div className="dates">{showPeriodNoTime(event.FirstDate, event.LastDate)}</div>
            </div>
        ),
    }));

    const onSelectChange = (value) => {
        // value puo' essere: null (clear button di CustomSelect)
        //                    | { value, label } (selezione con labelInValue)
        const eventUniqID = value ? value.value : null;
        setSelectedEventUniqID(eventUniqID);
        if (eventUniqID) {
            const event = events.find((e) => e.uniqID === eventUniqID);
            onChange(event);
        } else {
            onChange(null);
        }
    };

    return (
        <NwFormItem
            label={label}
            control={
                <Wrapper>
                    <CustomSelect
                        value={selectedEventUniqID}
                        onChange={onSelectChange}
                        options={eventOptions}
                        allowClear
                        disabled={disabled}
                        labelInValue
                        placeholder="No selected event"
                        dropdownMatchSelectWidth={false}
                        dropdownStyle={{ minWidth: DROPDOWN_MIN_WIDTH }}
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    />
                </Wrapper>
            }
        />
    );
};

export default BookingEventSelectorForTransactions;
